import { useEffect, useState } from 'react';
import { getIndices } from '../pages/api';
import { resolverPR } from '../utils/performanceRatio';

export default function usePerformanceRatio(proposta, modalidade = 'ongrid') {
  const [consulta, setConsulta] = useState({ indices: null, erro: '', carregando: true });
  const [tentativa, setTentativa] = useState(0);
  useEffect(() => {
    let ativo = true;
    setConsulta({ indices: null, erro: '', carregando: true });
    Promise.resolve().then(() => getIndices()).then((indices) => {
      if (!Array.isArray(indices)) throw new Error('Não foi possível consultar os índices.');
      if (ativo) setConsulta({ indices, erro: '', carregando: false });
    }).catch(() => {
      if (ativo) setConsulta({ indices: null, erro: 'Não foi possível consultar o PR. Tente novamente.', carregando: false });
    });
    return () => { ativo = false; };
  }, [tentativa]);

  let resolvido;
  let erro = '';
  try {
    resolvido = resolverPR({ proposta, indices: consulta.indices, modalidade });
    if (resolvido.pr === null && consulta.erro) erro = consulta.erro;
  } catch (e) {
    erro = e.message;
    resolvido = { pr: null, origem: 'erro', aviso: '' };
  }
  return {
    ...resolvido, erro, carregando: resolvido.pr === null && consulta.carregando,
    indices: consulta.indices, pronto: resolvido.pr !== null && !erro,
    recarregar: () => setTentativa((anterior) => anterior + 1),
  };
}
